import React, { ChangeEvent, FC, ReactNode } from 'react';
import classnames from 'classnames';

import { useInputError } from '../../_hooks';
import InputWrapper, { InputWrapperProps } from './InputWrapper';

import './inputField.scss';

export type InputFieldProps = InputWrapperProps & {
  autoComplete?: string;
  autoFocus?: boolean;
  icon?: ReactNode;
  normalize?: (value: string) => string | number;
  onChange: (value: string | number, name: string) => void;
  placeholder?: string;
  type?: 'email' | 'number' | 'password' | 'text';
  value?: string;
};

const InputField: FC<InputFieldProps> = ({
  autoComplete,
  autoFocus,
  icon,
  normalize,
  onChange,
  placeholder,
  type = 'text',
  value,
  ...wrapperProps
}) => {
  const { disabled, validation, name } = wrapperProps;
  const { setDirty, showError } = useInputError(validation);

  return (
    <InputWrapper {...wrapperProps} showError={showError}>
      <input
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        className={classnames('input', { error: showError })}
        disabled={disabled}
        name={name}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          const { value } = event.target;
          let normalizedValue = type === 'number' ? parseFloat(value) : value.trim();
          if (normalize) normalizedValue = normalize(value.trim());
          onChange(normalizedValue, name);
          setDirty();
        }}
        placeholder={placeholder}
        type={type}
        value={value}
      />
      {icon}
    </InputWrapper>
  );
};

export default InputField;
